import { render, staticRenderFns } from "./workDeductionList.vue?vue&type=template&id=56526a30&scoped=true"
import script from "./workDeductionList.vue?vue&type=script&lang=js"
export * from "./workDeductionList.vue?vue&type=script&lang=js"
import style0 from "./workDeductionList.vue?vue&type=style&index=0&id=56526a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56526a30",
  null
  
)

export default component.exports